export interface IEoStepperConfig {
  panels: IEoStepPanelConfig[];
  separator?: boolean;
  stepperButtonsVisible?: boolean;
  styleClass?: string;
  activeStep?: number;
  orientation?: 'horizontal' | 'vertical';
  linear?: boolean;
  transitionOptions?: string;
  nextButtonLabel?: string;
  nextButtonStyleClass?: string;
  nextButtonIcon?: string;
  nextButtonIconPosition?: 'left' | 'right';
  previousButtonLabel?: string;
  previousButtonStyleClass?: string;
  previousButtonIcon?: string;
  previousButtonIconPosition?: 'left' | 'right';
  submitButtonLabel?: string;
  submitButtonStyleClass?: string;
  submitButtonIcon?: string;
  submitButtonIconPosition?: 'left' | 'right';
  nextButtonDisabled?: boolean | ((param?: any) => boolean);
  nextButtonLoading?: boolean | ((param?: any) => boolean);
  previousButtonDisabled?: boolean | ((param?: any) => boolean);
  previousButtonLoading?: boolean | ((param?: any) => boolean);
  submitButtonDisabled?: boolean | ((param?: any) => boolean);
  submitButtonLoading?: boolean | ((param?: any) => boolean);
  nextButtonClick?: (event: any) => void;
  previousButtonClick?: (event: any) => void;
  submitButtonClick?: (event: any) => void;
  activeStepChange?: (step: number) => void;
}

export class EoStepperConfig implements IEoStepperConfig {
  panels: IEoStepPanelConfig[];
  separator?: boolean;
  stepperButtonsVisible?: boolean;
  styleClass?: string;
  activeStep?: number;
  orientation?: 'horizontal' | 'vertical';
  linear?: boolean;
  transitionOptions?: string;
  nextButtonLabel?: string;
  nextButtonStyleClass?: string;
  nextButtonIcon?: string;
  nextButtonIconPosition?: 'left' | 'right';
  previousButtonLabel?: string;
  previousButtonStyleClass?: string;
  previousButtonIcon?: string;
  previousButtonIconPosition?: 'left' | 'right';
  submitButtonLabel?: string;
  submitButtonStyleClass?: string;
  submitButtonIcon?: string;
  submitButtonIconPosition?: 'left' | 'right';
  nextButtonDisabled?: boolean | ((param?: any) => boolean);
  nextButtonLoading?: boolean | ((param?: any) => boolean);
  previousButtonDisabled?: boolean | ((param?: any) => boolean);
  previousButtonLoading?: boolean | ((param?: any) => boolean);
  submitButtonDisabled?: boolean | ((param?: any) => boolean);
  submitButtonLoading?: boolean | ((param?: any) => boolean);
  nextButtonClick?: (event: any) => void;
  previousButtonClick?: (event: any) => void;
  submitButtonClick?: (event: any) => void;
  activeStepChange?: (step: number) => void;

  constructor();
  constructor(obj: IEoStepperConfig);
  constructor(obj?: IEoStepperConfig) {
    this.panels = obj?.panels ?? [];
    this.separator = obj?.separator ?? true;
    this.stepperButtonsVisible = obj?.stepperButtonsVisible ?? true;
    this.styleClass = obj?.styleClass ?? '';
    this.activeStep = obj?.activeStep ?? 0;
    this.orientation = obj?.orientation ?? 'horizontal';
    this.linear = obj?.linear ?? false;
    this.transitionOptions =
      obj?.transitionOptions ?? '400ms cubic-bezier(0.86, 0, 0.07, 1)';
    this.nextButtonLabel = obj?.nextButtonLabel ?? 'Επόμενο';
    this.nextButtonStyleClass = obj?.nextButtonStyleClass ?? '';
    this.nextButtonIcon = obj?.nextButtonIcon ?? '';
    this.nextButtonIconPosition = obj?.nextButtonIconPosition ?? 'left';
    this.previousButtonLabel = obj?.previousButtonLabel ?? 'Προηγούμενο';
    this.previousButtonStyleClass = obj?.previousButtonStyleClass ?? '';
    this.previousButtonIcon = obj?.previousButtonIcon ?? '';
    this.previousButtonIconPosition = obj?.previousButtonIconPosition ?? 'left';
    this.submitButtonLabel = obj?.submitButtonLabel ?? 'Αποθήκευση';
    this.submitButtonStyleClass = obj?.submitButtonStyleClass ?? '';
    this.submitButtonIcon = obj?.submitButtonIcon ?? '';
    this.submitButtonIconPosition = obj?.submitButtonIconPosition ?? 'left';
    this.nextButtonDisabled = obj?.nextButtonDisabled ?? false;
    this.previousButtonDisabled = obj?.previousButtonDisabled ?? false;
    this.submitButtonDisabled = obj?.submitButtonDisabled ?? false;
    this.nextButtonClick = obj?.nextButtonClick;
    this.previousButtonClick = obj?.previousButtonClick;
    this.submitButtonClick = obj?.submitButtonClick;
    this.activeStepChange = obj?.activeStepChange;
    this.nextButtonLoading = obj?.nextButtonLoading ?? false;
    this.previousButtonLoading = obj?.previousButtonLoading ?? false;
    this.submitButtonLoading = obj?.submitButtonLoading ?? false;
  }
}

export interface IEoStepPanelConfig {
  header: string;
  name: string;
  index: number;
  nextButtonDisabled?: boolean | ((param?: any) => boolean);
  nextButtonLoading?: boolean | ((param?: any) => boolean);
  previousButtonDisabled?: boolean | ((param?: any) => boolean);
  previousButtonLoading?: boolean | ((param?: any) => boolean);
  nextButtonClick?: (event: any) => void;
  previousButtonClick?: (event: any) => void;
}

export class EoStepPanelConfig implements IEoStepPanelConfig {
  header: string;
  name: string;
  index: number;
  nextButtonDisabled?: boolean | ((param?: any) => boolean);
  nextButtonLoading?: boolean | ((param?: any) => boolean);
  previousButtonDisabled?: boolean | ((param?: any) => boolean);
  previousButtonLoading?: boolean | ((param?: any) => boolean);
  nextButtonClick?: (event: any) => void;
  previousButtonClick?: (event: any) => void;

  constructor();
  constructor(obj: IEoStepPanelConfig);
  constructor(obj?: IEoStepPanelConfig) {
    this.header = obj?.header ?? '';
    this.name = obj?.name ?? '';
    this.index = obj?.index ?? 0;
    this.nextButtonDisabled = obj?.nextButtonDisabled ?? false;
    this.previousButtonDisabled = obj?.previousButtonDisabled ?? false;
    this.nextButtonClick = obj?.nextButtonClick;
    this.previousButtonClick = obj?.previousButtonClick;
    this.nextButtonLoading = obj?.nextButtonLoading ?? false;
    this.previousButtonLoading = obj?.previousButtonLoading ?? false;
  }
}
